import type { ListBatchJobItemsParams } from "../../../../../lib/corpusApi";

export type FieldReannotationTabKey =
  "contradictions" | "updated" | "unchanged" | "overridden" | "kept" | "failed";

export interface FieldReannotationTabConfig {
  label: string;
  /** Query params sent to GET /batch-jobs/:id/items for this tab. */
  apiFilters: Pick<ListBatchJobItemsParams, "status" | "review" | "outcome">;
  /** Whether this tab's items still await a decision — gates the per-row Override and Keep
   *  actions. Every other tab is read-only history. */
  reviewable: boolean;
}

/** One tab per thing that can become of a document. Order here is display order. */
export const FIELD_REANNOTATION_TABS: Record<FieldReannotationTabKey, FieldReannotationTabConfig> =
  {
    contradictions: {
      label: "Contradicts a person",
      apiFilters: { review: "open", outcome: "contradicts_human" },
      reviewable: true,
    },
    updated: {
      label: "Updated",
      apiFilters: { outcome: "updated" },
      reviewable: false,
    },
    unchanged: {
      label: "Unchanged",
      apiFilters: { outcome: "unchanged" },
      reviewable: false,
    },
    overridden: {
      label: "Overridden",
      apiFilters: { review: "applied" },
      reviewable: false,
    },
    kept: {
      label: "Kept",
      apiFilters: { review: "dismissed" },
      reviewable: false,
    },
    failed: {
      label: "Failed",
      apiFilters: { status: "failed" },
      reviewable: false,
    },
  };

export const FIELD_REANNOTATION_TAB_ORDER: FieldReannotationTabKey[] = [
  "contradictions",
  "updated",
  "unchanged",
  "overridden",
  "kept",
  "failed",
];
